<app-banner-app [retroSelected]="true" [Parametros]="this.parametro" [PaginaAnterior]="'DuracionContrato'" [IdentLead]="this.leadId" [bitacoraId]="this.IdBitacora">
</app-banner-app>

<br>
<!-- Timelines -->
<div class="visibilidadDiv">
    <div class="container" style="width: 700px;">
        <div class="row">
            <div class="col">
                <br><br><br><br>
                <div id="stepper1" class="bs-stepper">
                    <div class="bs-stepper-header" style="text-align: center;">
                        <div class="step" data-target="#test-l-1">
                            <div>
                                <span class="bs-stepper-circle estiloTextoNum" style="background-color: #00AEC7;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-check-lg" viewBox="0 0 16 16">
                                        <path
                                            d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                    </svg>
                                </span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Arriendo</span>
                            </div>
                        </div>

                        <div class="line" style="background-color: #2D6DF6; height: 2px;  margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-2">
                            <div>
                                <span class="standby bs-stepper-circle estiloTextoNum"
                                    style="background-color: #2D6DF6;">2</span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Planes</span>
                            </div>
                        </div>

                        <div class="line" style="height: 2px;  margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-3">
                            <div>
                                <span class="standby bs-stepper-circle estiloTextoNum">3</span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Datos propietario</span>
                            </div>
                        </div>

                        <div class="line" style="height: 2px;  margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-4">
                            <div>
                                <span class="standby bs-stepper-circle estiloTextoNum">4</span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Inmueble</span>
                            </div>
                        </div>

                        <div class="line" style="height: 2px;  margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-5">
                            <div>
                                <span class="standby bs-stepper-circle estiloTextoNum">5</span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Datos inquilino</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
</div>

<!-- Progress Bar -->
<div class="container contenedorProgressBar">
    <br><br>
    <div class="row">
        <div class="col">
            <strong>
                <p class="progressBarActivo">Planes</p>
            </strong>
        </div>
        <div class="col">
            <strong>
                <p class="progressBarInactivo">Siguiente: Datos del propietario</p>
            </strong>
        </div>
    </div>
    <ngb-progressbar class="mb-3" type="primary" [value]="40" height=".5rem">
    </ngb-progressbar>
</div>

<app-texto-principal-planes [nombreTextoPrincipal]="this.nombreTextoPrincipal"
    [textoInferior]="this.textoInferior"></app-texto-principal-planes>

<br><br>
<app-cards-planes [identLead]="this.leadId" ></app-cards-planes>

<app-footer-app></app-footer-app>